export default __webpack_public_path__ + "static/media/property_1_6.e6568206.webp";